module Meevo.Components.Interceptors {

    export class JwtInterceptor {
        response(response) {          
            return response;
        }

        // Convert any date objects to string using moment before a request is made to server to avoid json serializer causing timezone to be applied
        request(config) {
            if (config.url.match(/^\/?(api)|(storage)/i)) {
                let token = window['bearerToken'] || sessionStorage.getItem('mil:meevo:token');
                if (token) {
                    config.headers.Authorization = 'Bearer ' + token;
                }
            }
            return config;
        }

        static factory(): Function {
            let svc = () => {
                return new JwtInterceptor();
            }

            
            return svc;
        };
    }

    angular.module("meevo.components.interceptors")
        .factory("meevo.components.interceptors.JwtInterceptor", JwtInterceptor.factory());
}
